<div class="topbar col-md-12" [ngClass]="topbarClass">
  <ng-content></ng-content>
</div>
